import { observer } from 'mobx-react';
import { MobxRouter } from 'mobx-router';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const Container = styled.div`
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  position: relative;
  width: 100%;
`;

function MainContent() {
  return (
    <Container>
      <MobxRouter store={store} />
    </Container>
  );
}

export default observer(MainContent);
